import {useAuth0} from '@auth0/auth0-react'
import {ErrorBanner} from '../ErrorBanner.tsx'

export const EmailNotVerifiedErrorBanner = () => {
  const {user, isLoading: loadingAuth0} = useAuth0()

  if (loadingAuth0) return null

  if (user?.email_verified) return null

  return (
    <ErrorBanner color={'orange'} buttons={[]}>
      Your email address is not verified. Check your inbox and spam folder for a verification email.
    </ErrorBanner>
  )
}
